
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/cookies",
      function () {
        return require("private-next-pages/policies/cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/cookies"])
      });
    }
  